import React from 'react'

export const ArrowIcon = () => {
  return (
    <svg width='8' height='13' viewBox='0 0 8 13' className='ArrowIcon' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.85 1.694L6.775.619.788 6.606l5.987 5.988 1.075-1.075-4.912-4.913z' fill='#ACACAC'
        fillRule='evenodd' />
    </svg>
  )
}



// WEBPACK FOOTER //
// ./client/icons/ArrowIcon.js